import React from 'react';

const ICONS = {
  lyrics: (
    <svg width="54" height="54" viewBox="0 0 24 24" fill="none">
      <path d="M7 4h7l3 3v13H7V4Z" stroke="#16a34a" strokeWidth="1.5" />
      <path d="M14 4v4h4M9 12h6M9 16h4" stroke="#16a34a" strokeWidth="1.5" />
    </svg>
  ),
  music: (
    <svg width="54" height="54" viewBox="0 0 24 24" fill="none">
      <path d="M9 18V6l9-2v12" stroke="#16a34a" strokeWidth="1.5" />
      <circle cx="6.5" cy="18" r="2.5" stroke="#16a34a" strokeWidth="1.5" />
      <circle cx="15.5" cy="16" r="2.5" stroke="#16a34a" strokeWidth="1.5" />
    </svg>
  ),
  video: (
    <svg width="54" height="54" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="5" width="18" height="14" rx="2" stroke="#16a34a" strokeWidth="1.5" />
      <circle cx="8" cy="12" r="2" stroke="#16a34a" strokeWidth="1.5" />
      <path d="M12 16l3-4 4 6" stroke="#16a34a" strokeWidth="1.5" />
    </svg>
  ),
};

export default function EmptyState({ type, title, desc, hint }) {
  return (
    <div className="mv-empty">
      <div className="mv-empty__icon">{ICONS[type]}</div>
      <h3>{title}</h3>
      <p>{desc}</p>
      <span>{hint}</span>
    </div>
  );
}
